import { render } from "./C2cSell.m.vue?vue&type=template&id=0be8011c&scoped=true"
import script from "./C2cSell.m.vue?vue&type=script&lang=js"
export * from "./C2cSell.m.vue?vue&type=script&lang=js"

import "./C2cSell.m.vue?vue&type=style&index=0&id=0be8011c&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be8011c"]])

export default __exports__